export enum NotificationActionTypes {
    Push_Notification= "Push_Notification",
    Mark_Notification = "Mark_Notification",
    Dismiss_Notification = "Dismiss_Notification",
    Reset_Notification_Collection = "Reset_Notification_Collection"
}